<template>
  <a
    href="//www.liveinternet.ru/click"
    target="_blank"
  >
    <img
      src="//counter.yadro.ru/logo?44.6"
      title="LiveInternet"
      alt=""
      border="0"
      width="31"
      height="31"
    />
  </a>
</template>

<script>
export default {
  name: 'CountersBlock'
}
</script>


// WEBPACK FOOTER //
// CountersBlock.vue?2ff483c4